<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Selecione a Eletiva/Optativa Desejada</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <div class="grid">
          <vs-row vs-w="12" v-if="error != ''">
            <vs-col vs-w="8">
              <vs-card>
                <vs-row vs-w="12">
                  {{ error }}
                </vs-row>
                <vs-row vs-w="12">
                  <vs-col justify="space-around" align="right">
                    <vs-button @click="goTo('/reenrollment')">
                      Voltar para a tela inicial
                    </vs-button>
                  </vs-col>
                </vs-row>
              </vs-card>
            </vs-col>
          </vs-row>
          <vs-row
            v-else
            v-for="courseClasses in classes"
            :key="courseClasses.DISCIPLINA"
            vs-w="12"
          >
            <vs-col vs-w="6" vs-type="flex">
              <vs-card>
                <vs-row vs-w="12">
                  {{ courseClasses.DISCIPLINA }}
                </vs-row>
                <vs-col vs-offset="9">
                  <vs-button @click="selectElective(courseClasses)">
                    Escolher esta
                  </vs-button>
                </vs-col>
              </vs-card>
            </vs-col>
          </vs-row>
        </div>
      </section>
    </div>
    <ConsultValidationRem />
  </div>
</template>

<script>
import getSeletivaElectives from "../services/courses";
import ConsultValidationRem from "../components/ConsultValidationRem.vue";
import {
  getStepsInformation,
  updateStepsInformation,
  formatDateToUSA,
} from "../helpers";

export default {
  name: "ElectiveReEnrollment",
  components: {
    ConsultValidationRem
  },
  data: () => ({
    ra: "",
    classes: [],
    error: "",
  }),

  methods: {
    selectElective(electiveSelected) {
      const { electives } = getStepsInformation();
      electives[0] = electiveSelected;
      updateStepsInformation({ electives });
      this.$router.push("/classreenrollment");
    },
    goTo(route) {
      this.$router.push(route);
    },
  },

  mounted() {
    const { offer, course } = getStepsInformation();

    this.$vs.loading({
      color: "danger",
    });

    let formatDate = formatDateToUSA(course.DATAMINREM);

    new getSeletivaElectives()
      .getEletivesRem(
        offer.CODCURSO,
        offer.IDHABILITACAOFILIAL,
        offer.IDCLASSIFICACAO,
        formatDate
      )
      .then(({ data }) => {
        this.classes = Array.isArray(data) ? data : [data];
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
};
</script>
